// Adresse for et sted bestiller har satt pin på i kartet. results/status er svaret fra Googles Geocoder
// (omvendt oppslag). Uten treff brukes koordinatene som tekst. pinned: true vises som «Pin på kart» (fullAddress).

export function pinAddress(lat, lng, results, status) {
  const best = status === 'OK' ? results?.[0] : null;
  if (!best?.formatted_address) {
    return { street: `Posisjon ${lat.toFixed(3)}, ${lng.toFixed(3)}`, city: '', lat, lng, pinned: true };
  }
  const city = best.address_components
    ?.find(c => c.types.includes('postal_town') || c.types.includes('locality'))
    ?.long_name ?? '';
  return { street: best.formatted_address, city, lat, lng, pinned: true };
}
